import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { App, Button, Dropdown, Popconfirm, Popover, Space, Tag } from 'antd';
import React, { useRef, useState } from 'react';
import { queryKeys } from '../../services/react-query/queryKeys';
import { MdDelete, MdModeEditOutline, MdSubtitles } from 'react-icons/md';
import Heading from '../../components/common/Heading/Heading';
import DynamicTableAnt from '../../hooks/DynamicTableAnt';
import { CheckOutlined, DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import StatusTag from '../../hooks/StatusHook';
import { useNavigate } from 'react-router-dom';
import {
  deleteStockReconcillation,
  getStockReconcillation,
} from '../../network/stockReconcillation';
import {
  cancelMaterialRequest,
  submitMaterialRequest,
} from '../../network/materialRequest';
import { TiCancel } from 'react-icons/ti';
import PropsSearchTable from '../../components/common/PropsSearchTable/PropsSearchTable';
import { PiDotsThreeVerticalBold } from 'react-icons/pi';
import { GiFiles } from 'react-icons/gi';
import { SiKnowledgebase } from 'react-icons/si';
import DashboardCards from '../Dashboard/DashboardCards';
const StockReconcillation = ({ t }) => {
  const navigate = useNavigate();
  const client = useQueryClient();
  const { message } = App.useApp();
  const searchInput = useRef(null);
  const searchInputMobile = useRef(null);
  const [textValue, setTextValue] = useState('');
  const [searchText, setSearchText] = useState({
    value: '',
    key: '',
  });
  const handleSearch = (selectedKeys, confirm, key) => {
    confirm();
    // console.log(`Searching for: ${selectedKeys[0]}, key: ${key}`);
    setSearchText({ value: selectedKeys[0], key });
  };

  const handleReset = (clearFilters, confirm) => {
    clearFilters();
    confirm();
    setSearchText({ value: '', key: '' });
  };
  const props = ({ key, name }) =>
    PropsSearchTable({
      key: key,
      name: name,
      setTextValue: setTextValue,
      textValue: textValue,
      setSearchText: setSearchText,
      searchInputMobile: searchInputMobile,
      searchInput: searchInput,
      handleSearch: handleSearch,
      handleReset: handleReset,
      t: t,
    });
  const handleRemove = useMutation({
    mutationFn: (id) => deleteStockReconcillation(id),
    onSuccess: (data) => {
      console.log(data, 'data');
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
      message.success(data?.message ? data?.message : 'Deleted successfully');
      client.invalidateQueries({
        queryKey: [queryKeys.getStockReconcillation],
      });
    },
    onError: () => {
      message.error('Something went wrong');
    },
  });
  const handleCancle = useMutation({
    mutationFn: (id) => cancelMaterialRequest('Stock Reconciliation', id),
    onSuccess: (data) => {
      console.log(data, 'data');
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
      message.success(data?.message?.message || 'Cancled successfully');
      client.invalidateQueries({
        queryKey: [queryKeys.getStockReconcillation],
      });
    },
    onError: () => {
      message.error('Something went wrong');
    },
  });
  const handleSubmit = useMutation({
    mutationFn: (id) => submitMaterialRequest('Stock Reconciliation', id),
    onSuccess: (data) => {
      console.log(data, 'data');
      if (data?.message?.status === 500 || !data) {
        message.error(data?.message?.message || 'Error occured');
        return false;
      }
      message.success(data?.message?.message || 'Submitted successfully');
      client.invalidateQueries({
        queryKey: [queryKeys.getStockReconcillation],
      });
    },
    onError: () => {
      message.error('Something went wrong');
    },
  });
  const { data, isLoading } = useQuery({
    queryKey: [
      queryKeys.getStockReconcillation,
      searchText.key,
      searchText.value,
    ],
    queryFn: () =>
      getStockReconcillation({
        key: searchText.key,
        value: searchText.value,
      }),
    keepPreviousData: true,
  });
  const items = (record) => [
    {
      key: '1',
      label: t.edit,
      icon: <MdModeEditOutline />,
      onClick: () => {
        navigate(`/stock-reconcillation/edit/${record?.name}`);
      },
    },
    // {
    //   key: '1-1',
    //   label: t.StockLedger,
    //   icon: <SiKnowledgebase />,
    //   disabled: record?.docstatus === 1 ? false : true,
    //   onClick: () => navigate(`/stock-ledger-report/${record?.name}`),
    // },
    // {
    //   key: '1-2',
    //   label: t.GeneralLedger,
    //   icon: <GiFiles />,
    //   disabled: record?.docstatus === 1 ? false : true,
    //   onClick: () => navigate(`/general-ledger-report/${record?.name}`),
    // },
    {
      key: '2',
      label: t.submit,
      icon: <CheckOutlined />,
      onClick: () => {
        handleSubmit.mutate(record.name);
      },
      disabled: record?.docstatus !== 0,
    },
    {
      key: '3',
      label: t.cancel,
      icon: <TiCancel />,
      onClick: () => {
        handleCancle.mutate(record.name);
      },
      disabled: record?.docstatus !== 0,
    },
    {
      type: 'divider',
    },
    {
      key: '8',
      label: (
        <Popconfirm
          title={t.DeletethePurchaseReciept + ` (${record?.name})`}
          description={t.areYouSure}
          onConfirm={() => handleRemove.mutate(record?.name)}
          // onCancel={cancel}
          okText={t.yes}
          cancelText={t.no}
        >
          <span style={{ color: 'red' }}>{t.Delete}</span>
        </Popconfirm>
      ),
      icon: <DeleteOutlined style={{ color: 'red' }} />,
    },
  ];
  const columns = [
    {
      title: t.Name,
      dataIndex: 'name',
      key: 'name',
      ...props({ key: 'name', name: t.Name }),
      render: (text, record) => {
        return (
          <span
            style={{ cursor: 'pointer' }}
            className="text-primary"
            onClick={() => {
              navigate(`/stock-reconcillation/edit/${record?.name}`);
            }}
          >
            {text}
          </span>
        );
      },
    },
    {
      title: t.purpose,
      dataIndex: 'purpose',
      key: 'purpose',
      ...props({ key: 'purpose', name: t.purpose }),
    },
    {
      title: t.differenceAmount,
      dataIndex: 'difference_amount',
      key: 'difference_amount',
      ...props({ key: 'difference_amount', name: t.differenceAmount }),
    },
    {
      title: t.postingDate,
      key: 'posting_date',
      dataIndex: 'posting_date',
    },
    {
      title: t.status,
      key: 'docstatus',
      dataIndex: 'docstatus',
      render: (text, record) => {
        return <StatusTag status={record?.docstatus} />;
      },
    },
    {
      title: t.action,
      dataIndex: 'action',
      key: 'action',
      width: 100,
      render: (text, record) => {
        return (
          <Space>
            {/* <Button
              size="small"
              type="primary"
              onClick={() => {
                navigate(`/stock-reconcillation/edit/${record?.name}`);
              }}
              icon={<MdModeEditOutline />}
            />
            {record?.docstatus === 0 && (
              <Popover
                placement="top"
                title={t.submit}
                onClick={() => {
                  handleSubmit.mutate(record?.name);
                }}
              >
                <Button
                  size="small"
                  type="primary"
                  style={{ backgroundColor: '#28a745' }}
                  icon={<MdSubtitles />}
                />
              </Popover>
            )}
            {record?.docstatus === 1 && (
              <Popover
                placement="top"
                title={t.Cancel}
                onClick={() => {
                  handleCancle.mutate(record?.name);
                }}
              >
                <Button
                  size="small"
                  type="primary"
                  style={{ backgroundColor: '#ff4d4f' }}
                  icon={<TiCancel />}
                />
              </Popover>
            )}
            {record?.docstatus !== 1 && (
              <Popconfirm
                title={t.DeletethePurchaseReciept + ` (${record?.name})`}
                description={t.areYouSure}
                onConfirm={() => handleRemove.mutate(record?.name)}
                okText={t.yes}
                cancelText={t.no}
              >
                <Button
                  size="small"
                  type="primary"
                  danger
                  icon={<MdDelete />}
                />
              </Popconfirm>
            )} */}
            <Dropdown
              menu={{ items: items(record) }}
              overlayClassName="custom-dropdown"
              trigger={['click']}
            >
              <Button
                type="text"
                icon={<PiDotsThreeVerticalBold size={20} color="#86888C" />}
              />
            </Dropdown>
          </Space>
        );
      },
    },
  ];
  const dataTable = data?.data?.map((item, index) => {
    return {
      key: index,
      ...item,
    };
  });
  return (
    <div className="inventory">
      {/* <Heading title={t.Inventory} subTitle={t.StockReconcillation} path="/" /> */}
      <DashboardCards t={t} />
      <div className="mt-5">
        <DynamicTableAnt
          columns={columns}
          data={dataTable}
          loading={isLoading}
          setSearchText={setSearchText}
          Placeholder={t.searchByName}
          buttonModal={
            <Button
              type="primary"
              onClick={() => {
                navigate('/stock-reconcillation/add');
              }}
            >
              <PlusOutlined
                style={{
                  fontSize: '10px',
                }}
              />
              {t.AddStockReconcillation}
            </Button>
          }
        />
      </div>
    </div>
  );
};

export default StockReconcillation;
